import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ConsumerActions } from "../actions/consumer.actions";
import { VendorActions } from "../actions/vendor.actions";
import { StatState } from "../models/stat-state";

const initialState: StatState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ConsumerActions.stats.getSuccess, (state, action) => _.omit(action, "type")),
	on(ConsumerActions.stats.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	),
	on(VendorActions.stats.getSuccess, (state, action) => _.omit(action, "type")),
	on(VendorActions.stats.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function statReducer(state: StatState | undefined, action: Action): StatState {
	return reducer(state, action);
}
